export default __webpack_public_path__ + "static/media/logo_mini.50c80591.svg";